import {
  OwnCompanyUserPropsFragment,
  AllCompanyUserPropsFragment,
  UserRole,
} from "@/shared/gql/graphql";

// strictly the Admin role
export const isAdminUser = ({
  user,
}: {
  user: OwnCompanyUserPropsFragment;
}): boolean => {
  return user.role === UserRole.Admin;
};

export const isCurrentUserAdmin = ({
  user,
}: {
  user: AllCompanyUserPropsFragment;
}): boolean => {
  return user.role === UserRole.Admin;
};

// "can manage" tier: Owner or Admin
export const isOwnerOrAdminUser = ({
  user,
}: {
  user: OwnCompanyUserPropsFragment;
}): boolean => {
  return user.role === UserRole.Owner || isAdminUser({ user });
};

export const isCurrentUserOwnerOrAdmin = ({
  user,
}: {
  user: AllCompanyUserPropsFragment;
}): boolean => {
  return user.role === UserRole.Owner || isCurrentUserAdmin({ user });
};

export const isCurrentUserOwner = ({
  user,
}: {
  user: AllCompanyUserPropsFragment;
}): boolean => {
  return user.role === UserRole.Owner;
};

// Display order for the role dropdowns — all roles are always shown; non-assignable ones are disabled.
export const userRoleOptions: UserRole[] = [
  UserRole.Owner,
  UserRole.Admin,
  UserRole.User,
];

// Whether the current user may assign a given role. Only an Owner may assign the Owner role.
export const canAssignRole = (
  role: UserRole,
  canAssignOwner: boolean,
): boolean => role !== UserRole.Owner || canAssignOwner;

// Whether the super admin control is shown at all: only super admins may manage it,
// and only for internal TenderApp staff (eligible by e-mail domain).
export const canManageSuperAdmin = ({
  currentUserIsSuperAdmin,
  targetIsEligible,
}: {
  currentUserIsSuperAdmin: boolean;
  targetIsEligible: boolean;
}): boolean => currentUserIsSuperAdmin && targetIsEligible;

export const userRoleLabels: Record<UserRole, string> = {
  [UserRole.Owner]: "Owner",
  [UserRole.Admin]: "Admin",
  [UserRole.User]: "User",
};

export const getUserFullName = (
  firstName: string | null,
  lastName: string | null,
  email?: string | null,
): string => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }

  if (firstName) {
    return firstName;
  }

  if (lastName) return lastName;

  return email || "Unknown User";
};
